import { Component, Prop, State, h } from '@stencil/core';

export interface INavbarItem {
  title: string;
  icon: string;
  active: boolean;
  event?: () => void;
  open?: boolean;
  subMenus?: Array<INavbarItem>;
}

@Component({
  tag: 'navbar-item',
  styleUrl: 'navbar-item.css',
  shadow: false,
})
export class MenuItem {
  @Prop() item: INavbarItem;

  @Prop() submenus: Array<INavbarItem>;

  @State() open: boolean = false;

  submenuOpen: string = '';

  toggleSubmenus = (submenu: INavbarItem) => {
    if (this.submenuOpen === submenu.title) {
      let element = document.getElementById(`submenu-${submenu.title}`);
      element.classList.remove(`open`);
      this.submenuOpen = '';
    } else {
      if (this.submenuOpen !== '') {
        let element = document.getElementById(`submenu-${this.submenuOpen}`);
        element.classList.remove(`open`);
      }

      let element = document.getElementById(`submenu-${submenu.title}`);
      element.classList.add(`open`);

      this.submenuOpen = submenu.title;
    }
  };

  toggleMenu = () => {
    if (this.submenuOpen !== '') {
      let element = document.getElementById(`submenu-${this.submenuOpen}`);
      element.classList.remove(`open`);
      this.submenuOpen = '';
    }
    this.open = !this.open;
    this.item.open = this.open;
    this.item.event && this.item?.event();
  };

  render() {
    let openIcon = this.open ? 'expand_less' : 'expand_more';

    return (
      <li class={`menu ${this.open ? 'open' : ''} menu-item ${this.item.active ? 'active' : ''}`}>
        <a
          class={``}
          onClick={() => {
            this.toggleMenu();
          }}
        >
          <div class={`menu-option ${this.item.active ? 'active' : ''}`}>
            <lab-ds-icon-not-selectable icon={this.item.icon} size="s-medium" />{' '}
            <span class="title-menu">
              {this.item.title} {this.submenus?.length > 0 && <lab-ds-icon-not-selectable icon={openIcon} size="small" />}
            </span>
          </div>
        </a>
        {this.submenus?.length > 0 && (
          <ul class="submenu-item">
            {this.submenus?.map(submenu => (
              <li id={`submenu-${submenu.title}`} class={`menu-item`}>
                <a
                  class={`${submenu.active ? 'active' : ''}`}
                  onClick={() => {
                    this.toggleSubmenus(submenu);
                    submenu.event && submenu.event();
                  }}
                >
                  <div class={`menu-option ${submenu.active ? 'active' : ''}`}>
                    <lab-ds-icon-not-selectable icon={submenu.icon} size="s-medium" />{' '}
                    <span class="title-menu">
                      {submenu.title}{' '}
                      {submenu.subMenus?.length > 0 && (
                        <span>
                          <lab-ds-icon-not-selectable class="icon-more" icon={'expand_more'} size="small" />
                          <lab-ds-icon-not-selectable class="icon-less" icon={'expand_less'} size="small" />
                        </span>
                      )}
                    </span>
                  </div>
                </a>
                {submenu.subMenus?.length > 0 && (
                  <ul class="sub-submenu-item">
                    {submenu.subMenus?.map(submenu => (
                      <li class={`menu-item`}>
                        <a
                          class={`${submenu.active ? 'active' : ''}`}
                          onClick={() => {
                            submenu.event();
                          }}
                        >
                          <div class={`menu-option ${submenu.active ? 'active' : ''}`}>
                            <lab-ds-icon-not-selectable icon={submenu.icon} size="s-medium" /> <span class="title-menu">{submenu.title}</span>
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  }
}
